import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeTop24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEdgeTop24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.125 16.125a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2-9.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zm13 8.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-15-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m15-1.32a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 8.32a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-11 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeTop24);
